import {
    IconButton, Slider, Switch, Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
    useEffect,
} from "react";
import { styled } from "@mui/material/styles";
import useStore from "../../store";
import PTMIcon from "../../Components/PTMIcon";
import { PTMLink } from "../../Components";

const ZoomSlider = styled(Slider)({
    padding: "8px 0",
    width: 100,
    margin: "0 5px",
    ".MuiSlider-thumb": {
        "&:focus, &:hover": {
            boxShadow: "0px 0px 0px 3px rgb(69, 148, 176, 16%)!important",
        },
        "&:active": {
            boxShadow: "0px 0px 0px 5px rgb(69, 148, 176, 16%)!important",
        },
        "& .bar": {
        },
        "&:after": {
            top: -3,
            left: -6,
            right: -6,
            bottom: -3,
        },
    },
});

const ThemeSwitch = styled(Switch)({
    height: 19,
    padding: 7.5,
    width: 35,
    ".MuiSwitch-switchBase": {
        padding: 0,
        top: 3.5,
        left: 1,
    },
    ".MuiSwitch-thumb": {
        width: 12,
        height: 12,
    },
    ".MuiSwitch-track": {
    },
    ".MuiSwitch-checked": {},
});

export default function Statusbar() {
    const darkMode = useStore((store) => store.app.darkMode);
    const setDarkMode = useStore((store) => store.app.setDarkMode);
    const zoom = useStore((store) => store.app.zoom);
    const setZoom = useStore((store) => store.app.setZoom);
    const electronConfig = useStore((store) => store.app.electronConfig);
    const systemIdleTime = useStore((store) => store.app.systemIdleTime);
    const isHelpDesk = useStore((store) => store.app.appInfo.is_helpdesk);
    // const openDialog = useStore((store) => store.dashboard.dialogs.setCurrentOpenDialog);

    const handleZoomSlider = (e, value) => {
        setZoom(value);
    };

    const handleZoomButtonMinus = () => {
        if (zoom > 0.1) {
            setZoom(zoom - 0.1);
        }
    };

    const handleZoomButtonPlus = () => {
        if (zoom < 2) {
            setZoom(zoom + 0.1);
        }
    };
    useEffect(() => {
        // TODO: handle Electron Zoom
        // contentRef.current.style.zoom = zoom;
        // sidebarRef.current.style.zoom = zoom;
        // window.dispatchEvent(new Event("resize"));
    }, [zoom]);

    const handleThemeSwitch = (e) => {
        setDarkMode(e.target.checked);
    };

    const handleThemeButtonDark = () => {
        if (!darkMode) {
            setDarkMode(true);
        }
    };

    const handleThemeButtonLight = () => {
        if (darkMode) {
            setDarkMode(false);
        }
    };

    return (
        <>
            {isHelpDesk && (
                <div style={{
                    display: "flex",
                    marginLeft: "auto",
                    padding: "0 5px",
                }}
                >
                    <PTMLink href="https://pt-systemhaus.de/impressum/" target="_blank">Impressum</PTMLink>
                    {" "}
                    |
                    {" "}
                    <PTMLink href="https://pt-systemhaus.de/datenschutzerklaerung/#Datenschutz-PTM" target="_blank">Datenschutz</PTMLink>
                </div>
            )}
            <div style={{
                display: "flex",
                marginLeft: "auto",
                padding: "0 5px",
            }}
            >
                <IconButton onClick={handleThemeButtonLight}>
                    <PTMIcon icon="sun" popover="Hell" style={{ fontSize: 10 }} fixedWidth />
                </IconButton>
                <ThemeSwitch color="default" checked={darkMode} onChange={handleThemeSwitch} />
                <IconButton onClick={handleThemeButtonDark}>
                    <PTMIcon icon="moon" popover="Dunkel" style={{ fontSize: 10 }} fixedWidth />
                </IconButton>
            </div>
            {/* eslint-disable-next-line no-undef */}
            {!_isBrowser ? (
                <div style={{
                    display: "contents",
                    marginLeft: "auto",
                    padding: "0 5px",
                    borderLeft: "1px solid",
                }}
                >
                    {electronConfig && (
                        <Typography
                            ml={2}
                            mr={5}
                            sx={{
                                display: "inline",
                                paddingTop: 1,
                            }}
                        >
                            Aktuelles Profil:
                            {" "}
                            {electronConfig.profiles[electronConfig.selectedProfile].profileName}
                        </Typography>
                    )}
                    <IconButton onClick={handleZoomButtonMinus}>
                        <FontAwesomeIcon style={{ fontSize: 10 }} icon="minus" fixedWidth />
                    </IconButton>
                    <ZoomSlider track={false} marks={[{ value: 1 }]} step={0.1} defaultValue={zoom} min={0.1} max={2} onChangeCommitted={handleZoomSlider} />
                    <IconButton onClick={handleZoomButtonPlus}>
                        <FontAwesomeIcon style={{ fontSize: 10 }} icon="plus" fixedWidth />
                    </IconButton>
                    <Typography
                        ml={2}
                        mr={5}
                        style={{
                            display: "inline",
                            paddingTop: 1,
                        }}
                    >
                        {Math.round(zoom * 100)}
                        %
                    </Typography>
                    {systemIdleTime !== null && !(electronConfig?.profiles && electronConfig.profiles[electronConfig.selectedProfile].disableSleepTimer) && (
                        <Typography
                            ml={2}
                            mr={5}
                            style={{
                                display: "inline",
                                paddingTop: 1,
                                minWidth: 45,
                            }}
                        >
                            Idle:
                            {" "}
                            {systemIdleTime}
                        </Typography>
                    )}
                </div>
            ) : null}
        </>
    );
}
